import { render } from "./AddVacancy.vue?vue&type=template&id=63424117"
import script from "./AddVacancy.vue?vue&type=script&lang=js"
export * from "./AddVacancy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__